var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clean"},[_vm._v("\n   清除缓存\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }